import { createSlice } from '@reduxjs/toolkit';

// Define the initial state using that type
const initialState: ITPMsState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null,
};

export const tpmsSlice = createSlice({
    name: 'tpms',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess , value } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: value ?? true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceTpms: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        setTpmsDetails: (state, action) => {
            state.details = action.payload.data;
        }
    },
});

export const tpmsActions = tpmsSlice.actions;

export default tpmsSlice.reducer;
